import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';
import AnalogProducts from './containers/AnalogProducts';
import { BroadcastProducts } from './containers/BroadcastProducts';
import { CompanySettings } from './containers/CompanySettings';
import { ConsultingProducts } from './containers/ConsultingProducts';
import {
  AdMediaForm,
  AdMediaHistory,
  AdMediaList,
  AdMediumMapping,
  AdPrice,
  AdTypes,
  Layout as DigitalProductsLayout,
  Placement,
  Products,
} from './containers/DigitalProducts';
import { PartnerFilialManagement } from './containers/PartnerFilialManagement';
import PointOfSaleProducts from './containers/PointOfSaleProducts';
import { PositionGroups } from './containers/PositionGroups';
import {
  AdMedias,
  AdPrices,
  AdTypes as PrintProductsAdTypes,
  Availabilities,
  Calendars,
  Layout as PrintProductsLayout,
  Placements,
  Products as PrintProductsRoot,
  SizeConfigs,
} from './containers/PrintProducts';
import { ReferencePerAdmedia } from './containers/ReferencePerAdmedia';

export default {
  AccountTypes: lazy(() => import('./containers/AccountTypes')),
  Helmet: lazy(() => import('./components/Helmet')),
  CampaignTypes: lazy(() => import('./containers/CampaignTypes')),
  CampaignTypesV2: lazyNamed(() => import('./containers/CampaignTypesV2'), 'CampaignTypes'),
  DataImport: lazy(() => import('./containers/DataImport')),
  Industries: lazyNamed(() => import('./containers/Industries'), 'Industries'),
  Labels: lazy(() => import('./containers/Labels')),
  PriceLists: lazy(() => import('./containers/PriceLists')),
  RoleBasedRedirector: lazy(() => import('./components/RoleBasedRedirector')),

  DigitalProducts: {
    Placement,
    Layout: DigitalProductsLayout,
    AdMediaList,
    AdMediaForm,
    AdMediaHistory,
    Products,
    AdPrice,
    AdTypes,
    AdMediumMapping,
  },

  BroadcastProducts,

  CompanySettings,

  AdSenseSettings: {
    Credentials: lazy(() => import('./containers/AdSense/Credentials')),
    Mappings: lazy(() => import('./containers/AdSense/Mappings')),
    OauthCallback: lazy(() => import('./containers/AdSense/Credentials/OauthCallback')),
    Layout: lazy(() => import('./containers/AdSense/Layout')),
  },

  XandrProgrammatic: {
    Overview: lazy(() => import('./containers/XandrProgrammatic/containers/Overview')),
    WebsitesMapping: lazy(() => import('./containers/XandrProgrammatic/containers/WebsitesMapping')),
    BrandsMapping: lazy(() => import('./containers/XandrProgrammatic/containers/BrandsMapping')),
    Deals: lazy(() => import('./containers/XandrProgrammatic/containers/Deals')),
    BuyerMapping: lazyNamed(() => import('./containers/XandrProgrammatic/containers/BuyerMapping'), 'BuyerMapping'),
    Layout: lazy(() => import('./containers/XandrProgrammatic/components/Layout')),
    OverviewRedirect: lazy(() => import('./containers/XandrProgrammatic/components/OverviewRedirect')),
  },

  GoogleProgrammatic: {
    WebsitesMapping: lazy(() => import('./containers/GoogleProgrammatic/containers/WebsitesMapping')),
    BrandsMapping: lazy(() => import('./containers/GoogleProgrammatic/containers/BrandsMapping')),
    BuyerMapping: lazyNamed(() => import('./containers/GoogleProgrammatic/containers/BuyerMapping'), 'BuyerMapping'),
    Layout: lazy(() => import('./containers/GoogleProgrammatic/Layout')),
  },

  AdomikProgrammatic: {
    Layout: lazyNamed(() => import('./containers/AdomikProgrammatic/components/Layout'), 'Layout'),
    WebsiteMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/WebsiteMappings'), 'WebsiteMappings'),
    BrandMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/BrandMappings'), 'BrandMappings'),
    BuyerMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/BuyerMappings'), 'BuyerMappings'),
    Deals: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/Deals'), 'Deals'),
    SSPMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/SSPMappings'), 'SSPMappings'),
    Seats: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/Seats'), 'Seats'),
  },

  PassendoProgrammatic: {
    Layout: lazy(() => import('src/scenes/Settings/containers/Passendo/Layout')),
    WebsitesMapping: lazy(() => import('src/scenes/Settings/containers/Passendo/WebsitesMapping')),
  },

  Brands: {
    List: lazy(() => import('./containers/Brands/containers/Brands')),
    Websites: lazy(() => import('./containers/Brands/containers/Websites')),
    Layout: lazy(() => import('./containers/Brands/components/Layout')),
  },

  PositionGroups,

  PrintProducts: {
    Layout: PrintProductsLayout,
    AdMedias,
    Placements,
    AdTypes: PrintProductsAdTypes,
    Products: PrintProductsRoot,
    AdPrices,
    Calendars,
    SizeConfigs,
    Availabilities,
  },

  ConsultingProducts,
  PointOfSaleProducts,

  Websites: {
    WebsitesList: lazyNamed(() => import('./containers/Websites/containers/WebsitesList'), 'WebsitesList'),
    WebsiteForm: lazyNamed(() => import('./containers/Websites/containers/WebsiteForm'), 'WebsiteForm'),
  },

  AnalogProducts,
  PartnerFilialManagement,

  SalesUnits: lazyNamed(() => import('./containers/SalesUnits'), 'SalesUnits'),
  ReferencePerAdmedia,
  SpecialDiscounts: lazyNamed(() => import('./containers/SpecialDiscounts'), 'SpecialDiscounts'),
};
